module.exports = __webpack_public_path__ + "static/media/maestro.be9e7831.png";